import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AjoutePromotion = async (data) => {
    return await axios.post(`${BASE_URL}/api/restaurant/ajoutePromotion`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}
const AffichePromotion = async (idRestaurant) => {
    return await axios.get(`${BASE_URL}/api/restaurant/affichePromotion/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}

const AffichePromotionSpecial = async (idRestaurant) => {
    return await axios.get(`${BASE_URL}/api/restaurant/affichePromotionSpecial/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}

const AffichePromotionRestaurant = async (idRestaurant) => {
    return await axios.get(`${BASE_URL}/api/restaurant/affichePromotionRestaurant/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}


export { AjoutePromotion, AffichePromotion, AffichePromotionSpecial, AffichePromotionRestaurant }